let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jowT6")).then(() => parcelRequire('48qyU'));